module.exports = __webpack_public_path__ + "static/bg_solutions_exhi.8b70ec86.jpg";